import { render } from "./ReplyMoreButton.vue?vue&type=template&id=fd52221c&ts=true"
import script from "./ReplyMoreButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReplyMoreButton.vue?vue&type=script&setup=true&lang=ts"

import "./ReplyMoreButton.vue?vue&type=style&index=0&id=fd52221c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/reply/ReplyMoreButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fd52221c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fd52221c', __exports__)) {
    api.reload('fd52221c', __exports__)
  }
  
  module.hot.accept("./ReplyMoreButton.vue?vue&type=template&id=fd52221c&ts=true", () => {
    api.rerender('fd52221c', render)
  })

}


export default __exports__